(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const onNextFrame = (callback) => requestAnimationFrame(() => requestAnimationFrame(callback));

  const animateCartFlight = (card) => {
    if (reducedMotion.matches) return;
    const image = card?.querySelector('.coasta-s1-product__image--main');
    const cart = [...document.querySelectorAll('.cart-drawer-button')].find((element) => element.offsetParent !== null);
    if (!image || !cart || !document.body.animate) return;

    const start = image.getBoundingClientRect();
    const end = cart.getBoundingClientRect();
    const clone = image.cloneNode(true);
    clone.className = 'coasta-cart-flight';
    Object.assign(clone.style, {
      position: 'fixed',
      zIndex: '9999',
      left: `${start.left}px`,
      top: `${start.top}px`,
      width: `${start.width}px`,
      height: `${start.height}px`,
      pointerEvents: 'none',
      objectFit: 'contain',
      padding: '0'
    });
    document.body.appendChild(clone);

    const x = end.left + end.width / 2 - (start.left + start.width / 2);
    const y = end.top + end.height / 2 - (start.top + start.height / 2);
    clone.animate([
      { transform: 'translate3d(0,0,0) scale(1)', opacity: 0.95, offset: 0 },
      { transform: `translate3d(${x * 0.55}px,${y * 0.42 - 48}px,0) scale(.52)`, opacity: 0.78, offset: 0.62 },
      { transform: `translate3d(${x}px,${y}px,0) scale(.08)`, opacity: 0.08, offset: 1 }
    ], { duration: 680, easing: 'cubic-bezier(.22,1,.36,1)' }).finished.finally(() => clone.remove());

    cart.classList.remove('coasta-cart-pulse');
    void cart.offsetWidth;
    cart.classList.add('coasta-cart-pulse');
    window.setTimeout(() => cart.classList.remove('coasta-cart-pulse'), 760);
  };

  const initCards = (root = document) => {
    root.querySelectorAll('[data-coasta-s1-swatch]').forEach((input) => {
      if (input.dataset.coastaBound === 'true') return;
      input.dataset.coastaBound = 'true';
      input.addEventListener('change', () => {
        const card = input.closest('[data-coasta-s1-product-card]');
        if (!card) return;
        const image = card.querySelector('.coasta-s1-product__image--main');
        const price = card.querySelector('[data-coasta-s1-price]');
        const compare = card.querySelector('[data-coasta-s1-compare]');
        const sale = card.querySelector('[data-coasta-save]');
        const variantInput = card.querySelector('[data-coasta-s1-variant-input]');
        const installmentInput = card.querySelector('[data-coasta-s1-installment-variant]');
        const terms = card.querySelector('shopify-payment-terms');
        const addButton = card.querySelector('[data-coasta-s1-add]');

        if (image && input.dataset.image) {
          image.src = input.dataset.image;
          image.removeAttribute('srcset');
        }
        if (price && input.dataset.price) price.textContent = input.dataset.price;
        if (compare) {
          compare.textContent = input.dataset.compare || '';
          compare.hidden = !input.dataset.compare;
        }
        if (sale) {
          sale.textContent = input.dataset.save || '';
          sale.hidden = !input.dataset.save;
        }
        if (variantInput && input.dataset.variantId) {
          variantInput.value = input.dataset.variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (installmentInput && input.dataset.variantId) {
          installmentInput.value = input.dataset.variantId;
          installmentInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (terms && input.dataset.variantId) terms.setAttribute('variant-id', input.dataset.variantId);
        if (addButton) addButton.disabled = input.dataset.available !== 'true';

        const label = input.nextElementSibling;
        label?.animate?.([
          { transform: 'scale(.8)' },
          { transform: 'scale(1.22)' },
          { transform: 'scale(1)' }
        ], { duration: 360, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      });
    });

    root.querySelectorAll('[data-coasta-product-interactive]').forEach((card) => {
      if (card.dataset.coastaInteractiveBound === 'true') return;
      card.dataset.coastaInteractiveBound = 'true';
      const media = card.querySelector('[data-coasta-product-media]');
      const addButton = card.querySelector('[data-coasta-s1-add]');

      if (media && finePointer.matches && !reducedMotion.matches) {
        media.addEventListener('pointermove', (event) => {
          const rect = media.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - 0.5) * 10;
          const y = ((event.clientY - rect.top) / rect.height - 0.5) * 7;
          card.style.setProperty('--coasta-product-x', `${x}px`);
          card.style.setProperty('--coasta-product-y', `${y}px`);
        });
        media.addEventListener('pointerleave', () => {
          card.style.setProperty('--coasta-product-x', '0px');
          card.style.setProperty('--coasta-product-y', '0px');
        });
      }
      addButton?.addEventListener('click', () => animateCartFlight(card));
    });
  };

  class CoastaS1Carousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.coastaBound === 'true') return;
      this.dataset.coastaBound = 'true';
      this.track = this.querySelector('[data-coasta-s1-track]');
      this.dots = this.querySelector('[data-coasta-s1-dots]');
      if (!this.track || !this.dots) return;
      this.slides = [...this.track.querySelectorAll('[data-coasta-s1-slide]')];
      this.renderDots();
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }
    renderDots() {
      this.dots.replaceChildren(...this.slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Go to product ${index + 1}`);
        button.addEventListener('click', () => slide.scrollIntoView({
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
          inline: 'start',
          block: 'nearest'
        }));
        return button;
      }));
    }
    update() {
      if (!this.slides.length || this.track.clientWidth >= this.track.scrollWidth - 2) {
        this.dots.hidden = true;
        return;
      }
      this.dots.hidden = false;
      const trackLeft = this.track.getBoundingClientRect().left;
      let nearest = 0;
      let nearestDistance = Infinity;
      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = index;
        }
      });
      [...this.dots.children].forEach((dot, index) => dot.setAttribute('aria-current', index === nearest ? 'true' : 'false'));
    }
  }

  class CoastaS1Adventure extends HTMLElement {
    connectedCallback() {
      if (this.dataset.coastaBound === 'true') return;
      this.dataset.coastaBound = 'true';
      this.cards = [...this.querySelectorAll('[data-coasta-adventure-card]')];
      if (!this.cards.length) return;
      this.cards.forEach((card) => {
        card.addEventListener('pointerenter', () => finePointer.matches && this.activate(card));
        card.addEventListener('focusin', () => this.activate(card));
      });
      this.addEventListener('pointerleave', () => {
        if (finePointer.matches) this.activate(this.cards[0]);
      });
    }
    activate(selected) {
      this.cards.forEach((card) => card.classList.toggle('is-active', card === selected));
    }
  }

  class CoastaS1Stories extends HTMLElement {
    connectedCallback() {
      if (this.dataset.coastaBound === 'true') return;
      this.dataset.coastaBound = 'true';
      this.track = this.querySelector('[data-coasta-stories-track]');
      this.progress = this.querySelector('[data-coasta-stories-progress]');
      this.cards = [...this.querySelectorAll('.coasta-s1-story')];
      if (!this.track) return;
      this.cards[0]?.classList.add('is-active');
      this.cards.forEach((card) => card.addEventListener('pointerenter', () => {
        if (!finePointer.matches) return;
        this.cards.forEach((item) => item.classList.toggle('is-active', item === card));
      }));

      this.dragging = false;
      this.moved = false;
      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.dragging = true;
        this.moved = false;
        this.startX = event.clientX;
        this.startScroll = this.track.scrollLeft;
        this.track.setPointerCapture?.(event.pointerId);
        this.track.classList.add('is-dragging');
      });
      this.track.addEventListener('pointermove', (event) => {
        if (!this.dragging) return;
        const delta = event.clientX - this.startX;
        if (Math.abs(delta) > 4) this.moved = true;
        this.track.scrollLeft = this.startScroll - delta;
      });
      const endDrag = () => {
        this.dragging = false;
        this.track.classList.remove('is-dragging');
      };
      this.track.addEventListener('pointerup', endDrag);
      this.track.addEventListener('pointercancel', endDrag);
      this.track.addEventListener('click', (event) => {
        if (this.moved) {
          event.preventDefault();
          event.stopPropagation();
          this.moved = false;
        }
      }, true);
      this.updateProgress = this.updateProgress.bind(this);
      this.track.addEventListener('scroll', this.updateProgress, { passive: true });
      window.addEventListener('resize', this.updateProgress, { passive: true });
      this.updateProgress();
    }
    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.updateProgress);
      window.removeEventListener('resize', this.updateProgress);
    }
    updateProgress() {
      if (!this.progress || !this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const ratio = max > 1 ? this.track.scrollLeft / max : 0;
      this.progress.style.transform = `scaleX(${max > 1 ? Math.max(.14, ratio) : 1})`;
    }
  }

  const initHero = (root = document) => {
    root.querySelectorAll('[data-coasta-hero]').forEach((hero) => {
      if (hero.dataset.coastaBound === 'true') return;
      hero.dataset.coastaBound = 'true';
      const media = hero.querySelector('[data-coasta-hero-media]');
      const content = hero.querySelector('[data-coasta-hero-content]');
      onNextFrame(() => hero.classList.add('is-entered'));

      let ticking = false;
      const updateScroll = () => {
        ticking = false;
        const rect = hero.getBoundingClientRect();
        const progress = clamp(-rect.top / Math.max(hero.offsetHeight * 0.88, 1));
        hero.style.setProperty('--coasta-hero-scroll', progress.toFixed(3));
        hero.style.setProperty('--coasta-hero-scale', (1 + progress * .035).toFixed(4));
        hero.style.setProperty('--coasta-hero-content-opacity', (1 - progress * .76).toFixed(3));
        hero.style.setProperty('--coasta-hero-content-y', `${(-34 * progress).toFixed(1)}px`);
      };
      window.addEventListener('scroll', () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateScroll);
        }
      }, { passive: true });
      updateScroll();

      if (media && content && finePointer.matches && !reducedMotion.matches) {
        hero.addEventListener('pointermove', (event) => {
          const rect = hero.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - .5) * 12;
          const y = ((event.clientY - rect.top) / rect.height - .5) * 8;
          hero.style.setProperty('--coasta-hero-x', `${x}px`);
          hero.style.setProperty('--coasta-hero-y', `${y}px`);
        });
        hero.addEventListener('pointerleave', () => {
          hero.style.setProperty('--coasta-hero-x', '0px');
          hero.style.setProperty('--coasta-hero-y', '0px');
        });
      }
    });
  };

  const initPerformance = (root = document) => {
    root.querySelectorAll('[data-coasta-performance]').forEach((section) => {
      if (section.dataset.coastaBound === 'true') return;
      section.dataset.coastaBound = 'true';
      const metrics = [...section.querySelectorAll('[data-coasta-performance-metric]')];
      const detail = section.querySelector('[data-coasta-performance-detail]');
      const value = section.querySelector('[data-coasta-performance-value]');
      const label = section.querySelector('[data-coasta-performance-label]');
      const description = section.querySelector('[data-coasta-performance-description]');
      if (!metrics.length || !detail) return;

      const activate = (metric) => {
        metrics.forEach((item) => {
          const active = item === metric;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        value.textContent = metric.dataset.value || '';
        label.textContent = metric.dataset.label || '';
        description.textContent = metric.dataset.description || '';
        detail.classList.remove('is-changing');
        void detail.offsetWidth;
        detail.classList.add('is-changing');
        const activeIndex = metrics.indexOf(metric);
        section.style.setProperty('--coasta-performance-index', activeIndex);
        section.style.setProperty('--coasta-performance-shift', `${((activeIndex - 2.5) * 1.5).toFixed(1)}px`);
      };
      metrics.forEach((metric) => {
        metric.addEventListener('click', () => activate(metric));
        metric.addEventListener('focus', () => activate(metric));
        metric.addEventListener('pointerenter', () => finePointer.matches && activate(metric));
      });
      activate(metrics.find((metric) => metric.classList.contains('is-active')) || metrics[0]);
    });
  };

  const initReveal = (root = document) => {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      root.querySelectorAll('[data-coasta-route-name], .coasta-s1-heading-row, .coasta-s1-adventure-card, .coasta-s1-product, .coasta-s1-performance__metric, .coasta-s1-performance__lower, .coasta-s1-story, .coasta-s1-payment-row').forEach((element) => element.classList.add('is-visible'));
      return;
    }
    const elements = [...root.querySelectorAll('.coasta-s1-heading-row, .coasta-s1-adventure-card, .coasta-s1-product, .coasta-s1-performance__metric, .coasta-s1-performance__lower, .coasta-s1-story, .coasta-s1-payment-row')]
      .filter((element) => element.dataset.coastaRevealBound !== 'true');
    if (!elements.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -7% 0px' });
    elements.forEach((element, index) => {
      element.dataset.coastaRevealBound = 'true';
      element.classList.add('coasta-reveal');
      element.style.setProperty('--coasta-reveal-delay', `${Math.min(index % 6, 5) * 55}ms`);
      observer.observe(element);
    });
  };

  const initHeader = () => {
    const header = document.querySelector('.template-index .header-section');
    if (!header || header.dataset.coastaBound === 'true') return;

    header.dataset.coastaBound = 'true';

    // Concept already owns the sticky-header behavior. Do not add a second
    // scroll-direction auto-hide layer: it can leave the transparent header
    // translated above the viewport inside Shopify theme preview/editor.
    header.classList.remove('coasta-smart-header', 'is-coasta-hidden');

    const keepHeaderVisible = () => {
      header.classList.remove('is-coasta-hidden');
    };

    keepHeaderVisible();
    window.addEventListener('pageshow', keepHeaderVisible);
    document.addEventListener('shopify:section:load', keepHeaderVisible);
    document.addEventListener('shopify:section:reorder', keepHeaderVisible);
  };

  const initMegaMenu = (root = document) => {
    root.querySelectorAll('[data-coasta-mega-tabs]').forEach((tabs) => {
      if (tabs.dataset.coastaMegaBound === 'true') return;
      tabs.dataset.coastaMegaBound = 'true';

      const buttons = [...tabs.querySelectorAll('button[role="tab"]')];
      if (!buttons.length) return;

      const syncAria = () => {
        const selected = Number.parseInt(tabs.getAttribute('selected-index') || '0', 10);
        buttons.forEach((button, index) => {
          button.setAttribute('aria-selected', index === selected ? 'true' : 'false');
        });
      };

      buttons.forEach((button, index) => {
        button.addEventListener('pointerenter', () => {
          if (!finePointer.matches || button.disabled) return;
          tabs.selectedIndex = index;
        });
        button.addEventListener('focusin', () => {
          if (!button.disabled) tabs.selectedIndex = index;
        });
      });

      const observer = new MutationObserver(syncAria);
      observer.observe(tabs, { attributes: true, attributeFilter: ['selected-index'] });
      syncAria();
    });
  };

  const initRouteProgress = () => {
    if (document.querySelector('.coasta-route-progress')) return;
    const sections = [...document.querySelectorAll('[data-coasta-route-name]')];
    if (sections.length < 3) return;
    const nav = document.createElement('nav');
    nav.className = 'coasta-route-progress';
    nav.setAttribute('aria-label', 'Homepage route');
    const rail = document.createElement('i');
    rail.className = 'coasta-route-progress__rail';
    const fill = document.createElement('b');
    fill.className = 'coasta-route-progress__fill';
    rail.appendChild(fill);
    nav.appendChild(rail);
    const buttons = sections.map((section, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.innerHTML = `<span>${String(index + 1).padStart(2, '0')}</span><em>${section.dataset.coastaRouteName}</em>`;
      button.setAttribute('aria-label', `Go to ${section.dataset.coastaRouteName}`);
      button.addEventListener('click', () => section.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' }));
      nav.appendChild(button);
      return button;
    });
    document.body.appendChild(nav);

    let ticking = false;
    const update = () => {
      ticking = false;
      const focusY = window.innerHeight * .46;
      let active = 0;
      let distance = Infinity;
      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        const center = rect.top + Math.min(rect.height, window.innerHeight) * .45;
        const currentDistance = Math.abs(center - focusY);
        if (currentDistance < distance) {
          active = index;
          distance = currentDistance;
        }
      });
      buttons.forEach((button, index) => {
        button.classList.toggle('is-active', index === active);
        if (index === active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      const progress = sections.length > 1 ? active / (sections.length - 1) : 0;
      fill.style.transform = `scaleY(${progress})`;
      nav.classList.toggle('is-on-light', !sections[active].classList.contains('coasta-s1-hero') && !sections[active].classList.contains('coasta-s1-performance'));
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initAll = (root = document) => {
    initCards(root);
    initHero(root);
    initPerformance(root);
    initReveal(root);
    initHeader();
    initMegaMenu(root);
    initRouteProgress();
  };

  if (!customElements.get('coasta-s1-carousel')) customElements.define('coasta-s1-carousel', CoastaS1Carousel);
  if (!customElements.get('coasta-s1-adventure')) customElements.define('coasta-s1-adventure', CoastaS1Adventure);
  if (!customElements.get('coasta-s1-stories')) customElements.define('coasta-s1-stories', CoastaS1Stories);

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('sectionsRenderingAPI:cached', () => requestAnimationFrame(() => initMegaMenu(document)));
})();
